import script from "./newIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./newIndex.vue?vue&type=script&setup=true&lang=js"

import "./newIndex.vue?vue&type=style&index=0&id=ad3f60f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad3f60f0"]])

export default __exports__